import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "@i18n";
import appointmentDelete from "@/apis/scheduleApis/appointmentDelete";
import { useLang } from "@/common/Contexts/LanguageContext";
import SELL_TRADE_DEFAULT_DATA from "@/pages/module-sell-trade/SELL_TRADE_DEFAULT_DATA";
import { sellTradeMainDesignSteps } from "@/pages/module-sell-trade/types";
import erp_cities_with_areas from "../../../data/lookups_language_customized/erp_cities_with_areas.json";
import { getPlatformInfo, parseJsonSafely } from "@/utils/GlobalJavascriptFunction";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import stepTransitions from "./stepTransitions.json";
import useLocalStorage from "@hooks/useLocalStorage";
import useBrandsData from "@hooks/useBrandsData";
import useCheckABFlag from "@hooks/useCheckABFlag";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
export var URL_SELL_TRADE_FORM = "/site/sell-trade-form";
export var URL_SELL_TRADE_LANDING = "/sell-trade";
var SellTradeContext = /*#__PURE__*/createContext(undefined);
export var LOCAL_STORAGE_KEY = "sell_trade_data";
var SellTradeProvider = function SellTradeProvider(_ref) {
  var children = _ref.children;
  // Initialize bigData with default values
  var _useState = useState(null),
    bigData = _useState[0],
    setBigData = _useState[1];
  var _useState2 = useState(false),
    showPopUp = _useState2[0],
    setShowPopUp = _useState2[1];
  var _useState3 = useState(false),
    mainFormDesign = _useState3[0],
    setMainFormDesign = _useState3[1];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var location = useLocation();
  var webview = useWebView();
  var isWebView = useIsWebView();
  var lang = useLang();
  var _useTranslation = useTranslation(["web_sell_trade"]),
    t = _useTranslation.t;
  var queryParams = new URLSearchParams(location.search);
  var _useState4 = useState(false),
    forceNavigated = _useState4[0],
    setForceNavigated = _useState4[1];
  var _useBrandsData = useBrandsData({
      forcedLang: "en"
    }),
    getMakeById = _useBrandsData.getMakeById,
    getModelById = _useBrandsData.getModelById,
    getExtensionById = _useBrandsData.getExtensionById;
  var isABTestEnabled = useCheckABFlag("AB_SELL_MY_CAR_V3");
  var infoFormStep = queryParams.get("formStep") || "";
  var _useState5 = useState(erp_cities_with_areas[lang]),
    cities_with_areas = _useState5[0];
  var _useState6 = useState([]),
    cities_with_areas_approved_for_inspection = _useState6[0],
    setCities_with_areas_approved_for_inspection = _useState6[1];
  var _useState7 = useState(false),
    fromV2 = _useState7[0],
    setFromV2 = _useState7[1];
  useEffect(function () {
    if (isWebView) {
      webview.showLoading(false)["catch"](function () {});
      webview.showBottomBar(false)["catch"](function () {});
    }
  }, [isWebView]);
  useEffect(function () {
    // Check if the URL contains 'from=sell_trade_v2' to determine if it's from V2
    var isFromV2 = sessionStorage.getItem('sell_trade_v2') === 'true';
    setFromV2(isFromV2);
  }, []);
  // Ensure cities_with_areas is a dependency for this effect
  useEffect(function () {
    setCities_with_areas_approved_for_inspection(cities_with_areas.filter(function (value) {
      return value.approved_for_inspection === true;
    }));
  }, [cities_with_areas]);
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {
      if (isWebView) {
        /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
        document.body.classList.add("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
      }
    });
    trackEvents("sell_car_form_landing", {
      platform: getPlatformInfo(),
      referral_location: "main_banner"
    });
    return function () {
      if (isWebView) {
        /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
        document.body.classList.remove("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
      }
    };
  }, [isWebView]);
  var getCity = function getCity(city_id) {
    if (!city_id || isNaN(city_id)) return null;
    return cities_with_areas.find(function (value) {
      return Number(value.id) === Number(city_id);
    });
  };
  var goToLanding = function goToLanding() {
    var sellTradeUrl = isABTestEnabled ? URL_SELL_TRADE_LANDING_v2 : URL_SELL_TRADE_LANDING;
    navigateToHard(sellTradeUrl);
  };
  useEffect(function () {
    setBigData(getInitialData());
  }, [location.search]); // Re-initialize when URL search params change

  useEffect(function () {
    console.log("====================================");
    console.log("bigData", bigData);
    console.log("====================================");
  }, [bigData]);
  var updateMainFormDesign = function updateMainFormDesign() {
    setMainFormDesign(sellTradeMainDesignSteps.includes(infoFormStep));
  };
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage;
  var getInitialData = function getInitialData() {
    var storedData = parseJsonSafely(getLocalStorage(LOCAL_STORAGE_KEY));
    var userData = parseJsonSafely(getLocalStorage("user"));
    var defaultData = SELL_TRADE_DEFAULT_DATA(userData, t);

    // Check for URL parameters to pre-fill car data
    var urlParams = new URLSearchParams(location.search);
    var makeId = urlParams.get('make_id') || urlParams.get('make');
    var modelId = urlParams.get('model_id') || urlParams.get('model');
    var trimId = urlParams.get('trim_id') || urlParams.get('trim');
    var year = urlParams.get('year');

    // If we have car data from URL, pre-fill the form
    if (makeId || modelId || year) {
      var carData = {
        car_make_id: makeId ? parseInt(makeId) : null,
        car_model_id: modelId ? parseInt(modelId) : null,
        car_trim_id: trimId ? parseInt(trimId) : null,
        year: year ? parseInt(year) : null
      };

      // Use stored data as base, but update car data from URL
      if (storedData) {
        storedData.Sell_car_form1 = _objectSpread(_objectSpread({}, storedData.Sell_car_form1), carData);
        return storedData;
      } else {
        // No stored data, use default with URL car data
        defaultData.Sell_car_form1 = _objectSpread(_objectSpread({}, defaultData.Sell_car_form1), carData);
        return defaultData;
      }
    }
    return storedData || defaultData;
  };
  var cleanUp = function cleanUp() {
    var _useLocalStorage2 = useLocalStorage(),
      removeLocalStorage = _useLocalStorage2.removeLocalStorage;
    removeLocalStorage(LOCAL_STORAGE_KEY);
    setBigData(getInitialData());
    console.log("Local storage cleared due to missing formStep.");
    setTimeout(function () {
      navigateToFormStep("sell_car_form1");
    }, 400);
  };
  useEffect(function () {
    var _useLocalStorage3 = useLocalStorage(),
      getLocalStorage = _useLocalStorage3.getLocalStorage;
    if (!forceNavigated) {
      if (!infoFormStep || !parseJsonSafely(getLocalStorage(LOCAL_STORAGE_KEY))) {
        cleanUp();
      } else {
        updateMainFormDesign();
      }
      updateData("steps.0.stepName", t("معلومات سيارتك", {
        ns: "web_sell_trade"
      }));
      updateData("steps.1.stepName", t("السعر التقديري", {
        ns: "web_sell_trade"
      }));
      updateData("steps.2.stepName", t("حجز موعد الفحص", {
        ns: "web_sell_trade"
      }));
      handleForceNavigation(infoFormStep);
    }
    setForceNavigated(false); // Reset flag after the effect runs
  }, [infoFormStep]); // Ensure this depends only on infoFormStep

  var handleForceNavigation = function handleForceNavigation(formStep) {
    var isRevisited = checkIfStepVisted(formStep);
    console.log("Navigating to step: ".concat(formStep, ", Is revisited: ").concat(isRevisited));
    if (isRevisited) {
      var latestTrueStep = (bigData === null || bigData === void 0 ? void 0 : bigData.latestTrueStep) || "";
      var forcedStep;
      // Use JSON to determine the forcedStep
      forcedStep = stepTransitions.steps[latestTrueStep] || stepTransitions.steps["default"];

      // Update visitedSteps: remove steps from forcedStep onwards
      if (bigData) {
        var forcedIndex = bigData.visitedSteps.indexOf(forcedStep);
        var updatedVisitedSteps = bigData.visitedSteps.slice(0, forcedIndex + 1);
        setBigData(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            visitedSteps: updatedVisitedSteps
          });
        });
      }
      setForceNavigated(true); // Prevent useEffect from reacting
      navigateToFormStep(forcedStep); // Trigger navigation to the specific step
    } else {
      // Update visited steps if the step is new
      if (bigData) {
        updateData("visitedSteps", [].concat(_toConsumableArray(bigData === null || bigData === void 0 ? void 0 : bigData.visitedSteps), [formStep]));
      }
      updateData("latestTrueStep", formStep);
    }
  };
  var checkIfStepVisted = function checkIfStepVisted(formStep) {
    var _bigData$visitedSteps;
    return bigData === null || bigData === void 0 ? void 0 : (_bigData$visitedSteps = bigData.visitedSteps) === null || _bigData$visitedSteps === void 0 ? void 0 : _bigData$visitedSteps.includes(formStep);
  };
  var navigateToFormStep = function navigateToFormStep(formStep) {
    navigateTo(URL_SELL_TRADE_FORM, {
      formStep: formStep
    });
  };
  var handleDeleteOrder = function handleDeleteOrder() {
    var _bigData$erpResData;
    if (bigData !== null && bigData !== void 0 && (_bigData$erpResData = bigData.erpResData) !== null && _bigData$erpResData !== void 0 && _bigData$erpResData.request_id) {
      var _bigData$erpResData2;
      appointmentDelete({
        request_id: bigData === null || bigData === void 0 ? void 0 : (_bigData$erpResData2 = bigData.erpResData) === null || _bigData$erpResData2 === void 0 ? void 0 : _bigData$erpResData2.request_id
      }).then(function () {
        goToLanding();
      });
    } else {
      goToLanding();
    }
  };
  var fireCancelEvent = function fireCancelEvent() {
    var _getMakeById, _bigData$Sell_car_for, _getModelById, _bigData$Sell_car_for2, _getExtensionById, _bigData$Sell_car_for3, _cities_with_areas$fi, _cities_with_areas$fi2, _bigData$Sell_car_for5, _bigData$Sell_car_for6, _bigData$userSelectio, _bigData$Sell_car_for7;
    var make = (_getMakeById = getMakeById(bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for = bigData.Sell_car_form1) === null || _bigData$Sell_car_for === void 0 ? void 0 : _bigData$Sell_car_for.car_make_id)) === null || _getMakeById === void 0 ? void 0 : _getMakeById.name;
    var model = (_getModelById = getModelById(bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for2 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for2 === void 0 ? void 0 : _bigData$Sell_car_for2.car_model_id)) === null || _getModelById === void 0 ? void 0 : _getModelById.name;
    var trim = (_getExtensionById = getExtensionById(bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for3 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for3 === void 0 ? void 0 : _bigData$Sell_car_for3.car_trim_id)) === null || _getExtensionById === void 0 ? void 0 : _getExtensionById.name;
    var city = ((_cities_with_areas$fi = cities_with_areas.filter(function (city) {
      var _bigData$Sell_car_for4;
      return Number(bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for4 = bigData.Sell_car_form2) === null || _bigData$Sell_car_for4 === void 0 ? void 0 : _bigData$Sell_car_for4.city_id) === Number(city === null || city === void 0 ? void 0 : city.id);
    })) === null || _cities_with_areas$fi === void 0 ? void 0 : (_cities_with_areas$fi2 = _cities_with_areas$fi[0]) === null || _cities_with_areas$fi2 === void 0 ? void 0 : _cities_with_areas$fi2.name_en) || "null";
    trackEvents("sell_car_request_canceled", {
      car_make: make || "null",
      car_model: model || "null",
      car_year: (bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for5 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for5 === void 0 ? void 0 : _bigData$Sell_car_for5.year) || "null",
      car_trim: trim || "null",
      car_odometer_range: (bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for6 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for6 === void 0 ? void 0 : _bigData$Sell_car_for6.odometer_range_id) || "null",
      car_city: city,
      asking_price: (bigData === null || bigData === void 0 ? void 0 : (_bigData$userSelectio = bigData.userSelection) === null || _bigData$userSelectio === void 0 ? void 0 : _bigData$userSelectio.asking_price) || "null",
      car_status: (bigData === null || bigData === void 0 ? void 0 : (_bigData$Sell_car_for7 = bigData.Sell_car_form1) === null || _bigData$Sell_car_for7 === void 0 ? void 0 : _bigData$Sell_car_for7.car_condition_id) || "null",
      step: infoFormStep || "null"
    });
  };
  var getCurrentTitle = function getCurrentTitle() {
    switch (infoFormStep) {
      case "sell_car_form1":
        return t("معلومات السيارة", {
          ns: "web_sell_trade"
        });
      case "sell_car_form2":
        return t("المعلومات الشخصية", {
          ns: "web_sell_trade"
        });
      case "sell_car_estimated_price":
        return t("سعر السيارة التقديري", {
          ns: "web_sell_trade"
        });
      case "sell_car_locations":
      case "sell_car_inspection_city":
        return t("حدد موقع الفحص", {
          ns: "web_sell_trade"
        });
      case "sell_car_appointment":
        return t("حجز موعد فحص السيارة", {
          ns: "web_sell_trade"
        });
      case "sell_car_change_city":
        return t("تغيير المدينة", {
          ns: "web_sell_trade"
        });
      case "sell_car_company_locations":
        return t("مراكز الفحص المعتمدة", {
          ns: "web_sell_trade"
        });
      case "sell_car_customer_locations":
        return t("تفاصيل الموقع", {
          ns: "web_sell_trade"
        });
      case "sell_car_estimated_price_not_accept":
      case "sell_car_no_estimated_price":
        return t("السعر المطلوب", {
          ns: "web_sell_trade"
        });
      case "sell_car_payment":
        return t("الدفع", {
          ns: "web_sell_trade"
        });
      default:
        return "";
    }
  };
  var calculateProgress = function calculateProgress(form, totalPercentage) {
    var totalFields = Object.keys(form).length;
    var filledFields = Object.values(form).filter(function (value) {
      return value !== null && value !== undefined;
    }).length;
    return filledFields / totalFields * totalPercentage;
  };
  var calculateOverallProgress = function calculateOverallProgress(forms) {
    var _bigData$steps, _bigData$steps$;
    if (!(bigData !== null && bigData !== void 0 && (_bigData$steps = bigData.steps) !== null && _bigData$steps !== void 0 && (_bigData$steps$ = _bigData$steps[0]) !== null && _bigData$steps$ !== void 0 && _bigData$steps$.active)) return (bigData === null || bigData === void 0 ? void 0 : bigData.progressPercentage) || 0;
    var formKeys = Object.keys(forms).filter(function (key) {
      return key !== "steps" && key !== "progressPercentage" && key !== "infoFormStep" && key !== "area_approved_for_inspection" && key !== "latestTrueStep" && key !== "visitedSteps";
    });
    var totalForms = formKeys.length;
    var totalProgress = 0;
    formKeys.forEach(function (key) {
      var form = forms[key];
      var formProgress = calculateProgress(form, 29); // Assuming each form is worth 29%
      totalProgress += formProgress;
    });
    return totalForms > 0 ? totalProgress / totalForms : 0;
  };
  var updateNestedDataAndProgress = function updateNestedDataAndProgress(prevData, path, value) {
    var keys = path.split(".");
    var current = prevData;
    keys.slice(0, -1).forEach(function (key) {
      current = current[key];
    });
    current[keys[keys.length - 1]] = value;
    var newProgress = calculateOverallProgress(prevData);
    var finalBigData = _objectSpread(_objectSpread({}, prevData), {}, {
      progressPercentage: newProgress
    });
    var _useLocalStorage4 = useLocalStorage(),
      setLocalStorage = _useLocalStorage4.setLocalStorage;
    setLocalStorage(LOCAL_STORAGE_KEY, JSON.stringify(finalBigData));
    return finalBigData;
  };
  var updateData = function updateData(path, value) {
    setBigData(function (prev) {
      return updateNestedDataAndProgress(prev, path, value);
    });
  };
  var confirmConfigs = {
    title: t("هل انت متأكد من إلغاء تقديم الطلب؟", {
      ns: "web_sell_trade"
    }),
    message: t("لن يتم حفظ المعلومات، وستحتاج إلى إعادة تعبئة بياناتك في حال التقديم مرة أخرى!", {
      ns: "web_sell_trade"
    }),
    noButton: t("متابعة تقديم الطلب", {
      ns: "web_sell_trade"
    }),
    yesButton: t("إلغاء تقديم الطلب", {
      ns: "web_sell_trade"
    })
  };
  return /*#__PURE__*/React.createElement(SellTradeContext.Provider, {
    value: {
      infoFormStep: infoFormStep,
      navigateToFormStep: navigateToFormStep,
      goToLanding: goToLanding,
      setShowPopUp: setShowPopUp,
      bigData: bigData,
      showPopUp: showPopUp,
      mainFormDesign: mainFormDesign,
      getCurrentTitle: getCurrentTitle,
      handleDeleteOrder: handleDeleteOrder,
      updateData: updateData,
      cities_with_areas: cities_with_areas,
      cities_with_areas_approved_for_inspection: cities_with_areas_approved_for_inspection,
      confirmConfigs: confirmConfigs,
      getCity: getCity,
      fireCancelEvent: fireCancelEvent
    }
  }, children);
};
export var useSellTrade = function useSellTrade() {
  var context = useContext(SellTradeContext);
  if (!context) {
    throw new Error("useSellTrade must be used within a SellTradeProvider");
  }
  return context;
};
export { SellTradeProvider };